module.exports = __webpack_public_path__ + "static/phoneHome-a66d70601f23488317bf49f9bd7b929e.png";